// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/product-card/product-card.component.scss
// module id = 444
// module chunks = 0